import { gql } from 'graphql-request'
import { fragmentMaskShapeQuery } from '../fragments/mask-shape'

export const ManyRoomsQuery = gql`
  query AllRooms(
    $limit: Int = 500
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
    $statuses: [Room__status_Input] = [published]
  ) {
    Rooms(
      draft: $isPreview
      limit: $limit
      locale: $locale
      where: {
        _status: { in: $statuses }
      }
    ) {
      docs {
        id
        title
        slug
        floor
        maskShape ${fragmentMaskShapeQuery}
        # derived on save in payload (utilities/derived-flags.ts) -- this used
        # to be three relation joins counted client side
        hasContent
      }
      totalDocs
    }
  }
`
